import { z } from "zod";

export const memberSchema = z.object({
  firstName: z.string().min(2, "First name is required"),
  lastName: z.string().min(2, "Last name is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  address: z.string().min(5, "Address is required"),
  zipCode: z.string().min(2, "Zip code is required"),
  city: z.string().min(2, "City is required"),
  country: z.string().min(2, "Country is required"),
  joinReason: z.string().optional(),
});
